import React from 'react';
import { Clock } from 'lucide-react';

interface ComingSoonProps {
  feature?: string;
}

// Placeholder for features not yet wired to live data / backend.
const ComingSoon: React.FC<ComingSoonProps> = ({ feature }) => (
  <div className="flex flex-col items-center justify-center min-h-[60vh] text-center p-6">
    <div className="w-16 h-16 rounded-full bg-blue-50 dark:bg-blue-900/30 flex items-center justify-center mb-4">
      <Clock className="w-8 h-8 text-blue-500" />
    </div>
    <h1 className="text-2xl font-bold text-gray-900 dark:text-white mb-2">
      {feature ? `${feature} — Coming Soon` : 'Coming Soon'}
    </h1>
    <p className="text-gray-500 dark:text-gray-400 max-w-md">
      This feature is being built and will be available shortly. WhatsApp is live now;
      telephony and other channels are on the way.
    </p>
  </div>
);

export default ComingSoon;
